define([
	"dojo/_base/declare",
	"SiteAdmin/SettingsTable",
	"csi/xml"
], function(declare,SettingsTable,xml) {

	return declare(SettingsTable, {
		onActionRequiresAcknowledgement: function(ac) {
			if (!ac.newValue) {
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("HasRenewalPeriod", xml.ATTR_BOOLEAN, false);
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("RenewalPeriodBeginsOnReceipt", xml.ATTR_BOOLEAN, false);
			}
		},

		onActionHasEffectivity: function(ac) {
			if (!ac.newValue) {
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("HasRenewalPeriod", xml.ATTR_BOOLEAN, false);
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("RenewalPeriodBeginsOnReceipt", xml.ATTR_BOOLEAN, false);
			}
		},

		onActionHasRenewalPeriod: function(ac) {
			if (!ac.newValue) {
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("RenewalPeriodBeginsOnReceipt", xml.ATTR_BOOLEAN, false);
			}
		}
	});
});